import React, { useEffect, useState } from "react";
import "./Community.css";
import CommunityCover from "./CommunityCover";
import img from "../../Images/Rectangle 20 (2).png";
import heart from "../../Images/Vector (4).png";
import redHeart from "../../Images/red-heart.png";
import whatsapp from "../../Images/Group 534.png";
import send from "../../Images/Vector (11).png";
import img2 from "../../Images/Rectangle 21.png";
import img3 from "../../Images/Rectangle 20 (3).png";
import logo from "../../Images/Group 1171279193.png";
import trash from "../../Images/Vector (15).png";
import noimage from "../../Images/common_Image.jpg";
import Header from "../../Layout/Header";
import Header2 from "../../Layout/Header2";
import { Link, useLocation, useNavigate } from "react-router-dom";
import HomeService from "../../Services/HomeService";
import { toast } from "react-toastify";
import HttpClientXml from "../../utils/HttpClientXml";
// import CommunityList from "./CommunityList";
import CommunityFavList from "./CommunityFavList";
import { IoArrowBackCircleSharp } from "react-icons/io5";
import MediaSlider from "../PropertyList/MediaSlider";

const styles = {
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  modal: {
    backgroundColor: "#fff",
    padding: "20px",
    borderRadius: "8px",
    width: "40%",
    boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
  },
};

const CommunityFav = () => {
  const [showInner, setShowInner] = useState(true);
  const [show, setShow] = useState(false);
  const [userId, setUserId] = useState("");
  // const [loggedInUserId, setLoggedInUserId] = useState("");
  const [clientShow, setClientShow] = useState(false);
  const [isPropertyDealer, setIsPropertyDealer] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [floor, setFloor] = useState([]);
  const [bhk, setBhk] = useState([]);
  const [ad, setAd] = useState({});
  const [clientInHandResponse, setClientInHandResponse] = useState([]);
  const [imagesForMediaSlider, setImagesForMediaSlider] = useState([]);
  const [isMediaSliderOpen, setIsMediaSliderOpen] = useState(false);
  const [clientInHandData, setClientInHandData] = useState({
    advertisementId: "",
    prefferredLocalities: "",
    minBudget: "",
    maxBudget: "",
    floor: "",
    minBhk: "",
    maxBhk: "",
  });

  const location = useLocation();
  const { dealerDetails, showInnerState } = location.state || {};

  const [dealer, setDealer] = useState({});

  useEffect(() => {
    if (dealerDetails) {
      setDealer(dealerDetails);
    }
  }, [dealerDetails]);

  // useEffect(() => {
  //   if (dealerDetails?.userId === userId) {
  //     setLoggedInUserId(dealerDetails?.userId)
  //   }
  // }, [userId])
  // useEffect(() => {
  //   if (loggedInUserId) {
  //     fetchAdvertisement()
  //   }
  // }, [loggedInUserId])

  // Property in hand requirement code
  const [propertyType, setPropertyType] = useState([]);
  const [propertyInHand, setPropertyInHand] = useState([]);
  const [selectedPropertyType, setSelectedPropertyType] = useState("");
  const [cities, setCities] = useState([]);
  const [facings, setFacings] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");
  const [selectedFacing, setSelectedFacing] = useState("");
  const [locality, setlocality] = useState("");
  const [address, setAddress] = useState("");
  const [area, setArea] = useState("");
  const [selectedBhk, setSelectedBhk] = useState("");

  const [selectedFloor, setSelectedFloor] = useState("");

  const [ownerName, setOwnerName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [price, setPrice] = useState("");
  const [images, setImages] = useState([]);
  const [features, setFeatures] = useState([]); // Added features state
  const [featureInput, setFeatureInput] = useState(""); // Input for adding features
  const navigate = useNavigate();

  console.log("EFB77", dealerDetails);

  const fetchPropertyInHand = async () => {
    console.log("DDS80", dealerDetails);

    if (!dealerDetails?._id) {
      console.error("Error: userId is required to fetch properties.");
      return;
    }

    try {
      if (dealerDetails) {
        setShowInner(showInnerState);
      }
      const response = await HomeService.fetchPropertyInHand(
        dealerDetails?._id,
      );
      console.log("CDE92", response.data);

      if (response?.status) {
        setPropertyInHand(response.data);
      }
    } catch (error) {
      console.error("Error fetching property data:", error);
    }
  };

  useEffect(() => {
    // Fetch property types
    async function fetchPropertyTypes() {
      try {
        const res = await HomeService.getPropertyTypes();

        if (res?.data) {
          setPropertyType(res.data);
        }
      } catch (error) {
        console.error("Error fetching property types:", error);
      }
    }

    // Fetch cities
    async function fetchCities() {
      try {
        const res = await HomeService.getCities({ userId: userId });
        console.log("JHG136", res);
        if (res?.data) {
          setCities(res.data);
        }
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    }

    // Fetch Facings
    async function fetchFacings() {
      try {
        const res = await HomeService.getFacings();
        if (res?.data) {
          setFacings(res.data);
        }
      } catch (error) {
        console.error("Error fetching facings:", error);
      }
    }

    // Fetch BHK
    async function fetchBhks() {
      try {
        const res = await HomeService.getBhks();
        if (res?.data) {
          setBhk(res.data);
        }
      } catch (error) {
        console.error("Error fetching bhks:", error);
      }
    }
    // Fetch Floor
    async function fetchFloors() {
      try {
        const res = await HomeService.getFloors();
        if (res?.data) {
          setFloor(res.data);
        }
      } catch (error) {
        console.error("Error fetching floors:", error);
      }
    }

    fetchPropertyTypes();
    fetchCities();
    // fetchBhks();
    // fetchFloors();
    fetchFacings();
  }, [userId]);

  useEffect(() => {
    fetchPropertyInHand();
    // console.log("all property", propertyInHand);
  }, [userId, dealerDetails]);

  useEffect(() => {
    // console.log("features array", features);
    fetchClientInHand();
    fetchPropertyInHand();
  }, [features, clientInHandData, dealerDetails]);

  const fetchClientInHand = async () => {
    // const res = await HomeService.getClientInHand();

    const res = await HomeService.getClientInHandById(dealerDetails?._id);
    console.log("WWD186", res.data);

    if (res?.status) {
      setClientInHandResponse(res.data);
    }
  };

  const handleImageUpload = async (e) => {
    const files = e.target.files;
    const uploadedImages = [];

    for (let i = 0; i < files.length; i++) {
      const data = new FormData();
      data.append("image", files[i]);

      try {
        const res = await HttpClientXml.fileUplode(
          "image-upload",
          "POST",
          data,
        );
        if (res?.image) {
          uploadedImages.push(res.image);
        }
      } catch (error) {
        toast.error("Failed to upload image: " + files[i].name);
        console.error("Error uploading image:", error);
      }
    }

    setImages((prevImages) => [...prevImages, ...uploadedImages]);
    toast.success("Images uploaded successfully!");
  };

  const handleAddFeature = () => {
    if (featureInput.trim() !== "") {
      setFeatures((prevFeatures) => [...prevFeatures, featureInput.trim()]);

      setFeatureInput("");
    } else {
      toast.error("Feature cannot be empty");
    }
  };

  const handleRemoveFeature = (featureToRemove) => {
    setFeatures((prevFeatures) =>
      prevFeatures.filter((feature) => feature !== featureToRemove),
    );
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !selectedPropertyType ||
      !selectedCity ||
      !locality ||
      !address ||
      !area ||
      !selectedBhk ||
      !selectedFloor ||
      !ownerName ||
      !phoneNumber ||
      !price ||
      images.length === 0
    ) {
      toast.error(
        "Please fill all required fields and upload at least one image.",
      );
      return;
    }

    const matchedPropertyType = propertyType.find(
      (property) => property.propertyType === selectedPropertyType,
    );
    const matchedCity = cities.find((city) => city.name === selectedCity);
    const matchedBhk = bhk.find((bhk) => bhk.bhk === selectedBhk);
    const matchedFloor = floor.find((floor) => floor.floor === selectedFloor);
    const matchedFacing = facings.find(
      (facing) => facing.facing === selectedFacing,
    );

    const data = {
      propertyType: matchedPropertyType?._id,
      city: matchedCity?._id,
      locality,
      address,
      area,
      bhk: matchedBhk?._id,
      floor: matchedFloor?._id,
      ownerName,
      phoneNo: phoneNumber,
      price,
      images,
      facing: matchedFacing._id,
      features,
      addedByDealer: userId,
      // userId: userId
    };

    try {
      // console.log("submitted data", data);

      const res = await HomeService.postPropertyInHand(data);
      if (res?.status) {
        toast.success("Property added successfully!");
        setImages([]);
        fetchPropertyInHand();
        // setPropertyInHand(res.data);
      }
    } catch (error) {
      toast.error("Failed to add property.");
      console.error("Error adding property:", error);
    }
  };
  // Property in hand requirement code

  const handleChange = () => {
    setShow(!show);
  };
  const modalChange = () => {
    setModalOpen(!modalOpen);
  };

  const submitButtonfunc = async (e) => {
    e.preventDefault();
    // setClientShow(true);
    // console.log("submitted data", clientInHandData);

    const res = await HomeService.postClientInHandRequirement(clientInHandData);
    // console.log("res", res);

    if (res?.status) {
      // console.log("client in hand requirement added");
    }
    setClientInHandData({
      advertisementId: "",
      prefferredLocalities: "",
      minBudget: "",
      maxBudget: "",
      floor: "",
      minBhk: "",
      maxBhk: "",
    });
  };

  const fetchLoginProfile = async () => {
    const response = await HomeService.getLoginProfile();
    console.log("ASD331", response?.data);
    if (!response.status) {
      navigate("/profile");
    }
    if (response?.status) {
      setUserId(response?.data?._id);
    }
  };

  const fetchAllFloor = async () => {
    const response = await HomeService.getFloors();
    if (response?.status) {
      setFloor(response?.data);
    }
  };
  const fetchAllBhk = async () => {
    const response = await HomeService.getBhks();
    if (response?.status) {
      setBhk(response?.data);
    }
  };

  useEffect(() => {
    fetchLoginProfile();
    // fetchAllFloor();
    // fetchAllBhk();
  }, [userId]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [showInner]);

  useEffect(() => {
    // console.log("dealer details", dealerDetails);
    // console.log("dealer userid", dealerDetails?.userId, "user id", userId);

    if (dealerDetails?._id === userId) {
      // console.log("ispropertyDealer before ", isPropertyDealer);

      setIsPropertyDealer(true);
      // console.log("ispropertyDealer after ", isPropertyDealer);

      setClientInHandData((prevData) => ({
        ...prevData,
        advertisementId: dealerDetails?._id,
      }));
    }
  }, [userId, dealerDetails]);

  // const fetchAdvertisement = async () => {
  //   const res = await HomeService.getAllAdvertisement()
  //   if (res?.status) {
  //     const ad = res.data.find((ad) => {
  //       if (ad.userId === loggedInUserId) {
  //         return true
  //       }
  //     })
  //     setAd(ad)

  //   }
  // }
  const goBack = (e) => {
    e.preventDefault();
    console.log("ADR423", userId, dealerDetails?._id);
    setIsPropertyDealer(false);
    setShowInner(!showInner);
    // navigate(0)
    navigate("/community-fav-list", { state: {}, replace: true });
    // setShowInner(false)
  };

  const [showUpdateProfileModal, setShowUpdateProfileModal] = useState(false);
  console.log("YYPOI414", dealerDetails);

  const initialUpdateData = {
    fullName: "",
    email: "",
    mobileNo: "",
    companyName: "",
    city: "",
    workExpYear: "",
    address: "",
  };
  const [updateData, setUpdateData] = useState(initialUpdateData);

  useEffect(() => {
    setUpdateData({
      image: dealerDetails?.image,
      logo: dealerDetails?.logo,
      fullName: dealerDetails?.fullName,
      email: dealerDetails?.email,
      mobileNo: dealerDetails?.mobileNo,
      companyName: dealerDetails?.companyName,
      city: dealerDetails?.city?._id,
      workExpYear: dealerDetails?.workExpYear,
      address: dealerDetails?.address,
    });
  }, [dealerDetails]);

  const handleProfileImageUpload = async (e) => {
    const files = e.target.files;
    const uploadedImages = [];

    for (let i = 0; i < files.length; i++) {
      const data = new FormData();
      data.append("image", files[i]);

      try {
        const res = await HttpClientXml.fileUplode(
          "image-upload",
          "POST",
          data,
        );
        if (res?.image) {
          setUpdateData({ ...updateData, [e.target.name]: res.image });
        }
      } catch (error) {
        toast.error("Failed to upload image: " + files[i].name);
        console.error("Error uploading image:", error);
      }
    }

    setImages((prevImages) => [...prevImages, ...uploadedImages]);
    toast.success("Images uploaded successfully!");
  };

  const updateProfileData = async (e) => {
    e.preventDefault();
    console.log("TTR427", updateData);
    try {
      // console.log("submitted data", data);

      const res = await HomeService.updateProfile(updateData);

      if (res?.status) {
        toast.success("Profile updated successfully!");
        setShowUpdateProfileModal(!showUpdateProfileModal);
        setDealer({ ...updateData });
      } else {
        toast.error(toast.message);
      }
    } catch (error) {
      toast.error("Failed to add property.");
      console.error("Error adding property:", error);
    }
  };

  const [isFav, setIsFav] = useState(dealer?.isFavorite || false);
  const handleFavourite = async (id) => {
    try {
      const res = await HomeService.makeFavouriteCommunity({
        communityUserId: id,
      });

      if (res?.status) {
        toast.success(res?.message);
        setIsFav(!isFav);
      } else {
        toast.error(toast.message);
      }
    } catch (error) {
      // toast.error("Failed to add property.");
      console.error("Error adding favourite:", error);
    }
  };

  const getFirstImage = (mediaUrls) => {
    const imageExtensions = [
      ".jpg",
      ".jpeg",
      ".png",
      ".gif",
      ".webp",
      ".bmp",
      ".svg",
      ".avif",
    ];

    const image = mediaUrls.find((url) => {
      const lowerUrl = url.toLowerCase();

      return imageExtensions.some((ext) => lowerUrl.endsWith(ext));
    });

    return image || "";
  };

  return (
    <>
      <>
        {isMediaSliderOpen && (
          <MediaSlider
            mediaArray={imagesForMediaSlider}
            onClose={() => {
              setIsMediaSliderOpen(false);
            }}
          />
        )}
        {showInner ? (
          <>
            <CommunityFavList setShowInner={setShowInner} />
          </>
        ) : (
          <>
            <Header />
            {/* <Header2 /> */}
            {/* <div
              style={{ padding: "10px", cursor: "pointer" }}
              onClick={(e) => goBack(e)}
            >
              Back
            </div> */}
            <div
              style={{
                paddingLeft: "40px",
                cursor: "pointer",
                fontSize: "20px",
                color: "#0c1666",
                height: "55px",
                width: "55px",
                paddingTop: "20px",
              }}
              onClick={(e) => goBack(e)}
            >
              <IoArrowBackCircleSharp
                style={{ height: "45px", width: "45px" }}
              />
              {/* Back */}
            </div>
            <div className="community_wrapper">
              <div className="community_property_details_wrapper">
                <div className="property_img_details_div">
                  <div className="property_img_details_inside_content_wrapper">
                    <div className="property_img_details_content">
                      <div className="community_property_img">
                        <img
                          style={{
                            width: "100%",
                            maxWidth: "100%",
                            minWidth: "100%",
                            objectFit: "cover",
                            height: "100%",
                            borderRadius: "10px",
                          }}
                          // onClick={() => handleChange()}
                          src={dealer?.image || dealerDetails?.image}
                          alt="dealer"
                        ></img>
                        <div className="community_property_name_div">
                          <p>{dealer?.fullName || dealerDetails?.fullName}</p>
                          <p style={{ fontWeight: "600", color: "#0a591f" }}>
                            {dealer?.companyName || dealerDetails?.companyName}
                          </p>
                        </div>
                        <div className="community_property_logo_div_wrapper5">
                          <img src={dealer?.logo || dealerDetails?.logo}></img>
                        </div>
                      </div>
                      <div className="community_property_names">
                        <div
                          className="d-flex"
                          style={{ display: "flex", columnGap: "5px" }}
                        >
                          <sapn className="first_span">Business Filed:</sapn>
                          <span className="second_span">
                            {dealer?.businessField ||
                              dealerDetails?.businessField}
                            {/* {dealerDetails?.businessField
                              ?.map((field) => field?.name)
                              .join(", ")} */}
                          </span>
                        </div>
                        <div style={{ display: "flex", columnGap: "5px" }}>
                          <span className="first_span">Major Locality:</span>
                          <span className="second_span">
                            {dealer?.address || dealerDetails?.majorLocality}
                          </span>
                        </div>
                        <div style={{ display: "flex", columnGap: "5px" }}>
                          <span className="first_span">
                            Working Experience:
                          </span>
                          <span className="second_span">
                            {dealer?.workExpYear || dealerDetails?.workExpYear}
                          </span>
                        </div>
                      </div>
                      <div className="like_skip_div_wrapper">
                        {/* {!isPropertyDealer ? (
                          <>
                            <div className="like_skip_button_div">
                              <button
                                className="skip_btn"
                                onClick={() => handleFavourite(dealer?._id)}
                              >
                                Like
                              </button>
                              
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="like_skip_button_div">
                              <button
                                onClick={() =>
                                  setShowUpdateProfileModal(
                                    !showUpdateProfileModal,
                                  )
                                }
                                className="skip_btn"
                              >
                                Edit
                              </button>
                            </div>
                          </>
                        )} */}

                        {/* <div className="community_property_icons_div">
                          {!isPropertyDealer && (
                            <>
                              <div
                                className="icon_no_1"
                                onClick={() => handleFavourite(dealer?._id)}
                              >
                                <img src={redHeart}></img>
                              </div>
                            </>
                          )}

                          <div className="icon_no_1">
                            <img src={whatsapp}></img>
                          </div>
                          <div className="icon_no_1">
                            <img src={send}></img>
                          </div>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="client_property_details">
                  {clientInHandResponse.length > 0 ? (
                    <div>
                      {clientInHandResponse.map((ele) => (
                        <div
                          className="client_in_hand_wrapper"
                          style={{ marginBottom: "3px" }}
                        >
                          <div>
                            <div className="client_head_div">
                              <h3>Client In Hand (Requirement) </h3>
                            </div>

                            <div className="community_form_wrapper_div">
                              <form>
                                <div
                                  className="right_client_hand_details_div"
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    rowGap: "8px",
                                  }}
                                >
                                  <div className="d-flex justify-content-between align-items-center">
                                    <div
                                      className="d-flex justify-content-start align-items-center"
                                      style={{ columnGap: "8px" }}
                                    >
                                      <div>
                                        <p className="preferred_para">
                                          Preferred Localities:
                                        </p>
                                        <p className="city_name">
                                          {ele?.prefferredLocalities}
                                        </p>
                                      </div>
                                    </div>
                                    {isPropertyDealer ? (
                                      <div className="delete_icon_div">
                                        <img src={trash}></img>
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                  <div
                                    className="d-flex justify-content-start align-items-center"
                                    style={{ columnGap: "8px" }}
                                  >
                                    <div>
                                      <p className="preferred_para">Budget:</p>
                                      <p className="city_name">
                                        ₹{ele?.minBudget} {ele?.priceUnit} - ₹
                                        {ele?.maxBudget} {ele?.priceUnit}
                                      </p>
                                    </div>
                                  </div>

                                  <div
                                    className="d-flex justify-content-start align-items-center"
                                    style={{ columnGap: "8px" }}
                                  >
                                    <div>
                                      <p className="preferred_para">Area:</p>
                                      <p className="city_name">
                                        {ele?.minArea} {ele?.areaUnit} -{" "}
                                        {ele?.maxArea} {ele?.areaUnit}
                                      </p>
                                    </div>
                                  </div>

                                  <div
                                    className="d-flex justify-content-start align-items-center"
                                    style={{ columnGap: "8px" }}
                                  >
                                    <div>
                                      <p className="preferred_para">Floor:</p>
                                      <p className="city_name">{ele?.floor}</p>
                                    </div>
                                  </div>

                                  <div
                                    className="d-flex justify-content-start align-items-center"
                                    style={{ columnGap: "8px" }}
                                  >
                                    <div>
                                      <p className="preferred_para">BHK:</p>
                                      <p className="city_name">
                                        {ele?.minBhk} - {ele?.maxBhk}
                                      </p>
                                    </div>
                                  </div>
                                  <div
                                    className="d-flex justify-content-start align-items-start"
                                    style={{ columnGap: "8px" }}
                                  >
                                    <div>
                                      <p className="preferred_para">
                                        REQUIREMENTS:
                                      </p>
                                      <p className="city_name">
                                        {ele?.requirement}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <>
                      <div
                        className="client_in_hand_wrapper"
                        style={{ marginBottom: "3px" }}
                      >
                        <div>
                          <div className="client_head_div">
                            <h3>No Clients found In Hand</h3>
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  {isPropertyDealer ? (
                    <div className="client_in_hand_wrapper">
                      <div className="client_head_div">
                        <h3>Client In Hand (Requirement) </h3>
                      </div>
                      <div className="community_form_wrapper_div">
                        <form
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            rowGap: "10px",
                          }}
                        >
                          <div className="community_form_filed_wrapper">
                            <label className="community_form_label">
                              Preferred Localities
                            </label>
                            <div className="community_input_wrapper_div">
                              <input
                                value={clientInHandData.prefferredLocalities}
                                onChange={(e) => {
                                  setClientInHandData((prevData) => ({
                                    ...prevData,
                                    prefferredLocalities: e.target.value,
                                  }));
                                }}
                                placeholder="Enter Preferred Localities"
                                type="text"
                              ></input>
                            </div>
                          </div>

                          <div className="community_input_flex_wrapper">
                            <div className="left_form_wrappr">
                              <div className="community_form_filed_wrapper">
                                <label className="community_form_label">
                                  Min. Budget
                                </label>
                                <div className="community_input_wrapper_div">
                                  <input
                                    value={clientInHandData.minBudget}
                                    onChange={(e) => {
                                      setClientInHandData((prevData) => ({
                                        ...prevData,
                                        minBudget: Number(e.target.value),
                                      }));
                                    }}
                                    placeholder="Enter Amount"
                                    type="Number"
                                  ></input>
                                </div>
                              </div>
                            </div>
                            <div className="right_form_wrapper">
                              <div className="community_form_filed_wrapper">
                                <label className="community_form_label">
                                  Max. Budget
                                </label>
                                <div className="community_input_wrapper_div">
                                  <input
                                    value={clientInHandData.maxBudget}
                                    onChange={(e) => {
                                      setClientInHandData((prevData) => ({
                                        ...prevData,
                                        maxBudget: Number(e.target.value),
                                      }));
                                    }}
                                    placeholder="Enter Amount"
                                    type="Number"
                                  ></input>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="community_form_filed_wrapper">
                            <label className="community_form_label">
                              Floor
                            </label>
                            <div className="community_input_wrapper_div">
                              <select
                                // placeholder="Enter Floor"
                                type="text"
                                value={clientInHandData.floor}
                                onChange={(e) => {
                                  setClientInHandData((prevData) => ({
                                    ...prevData,
                                    floor: e.target.value,
                                  }));
                                }}
                              >
                                <option value="">Select Floor</option>
                                {floor.map((floor) => (
                                  <option key={floor._id} value={floor._id}>
                                    {floor.floor}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>

                          <div className="community_input_flex_wrapper">
                            <div className="left_form_wrappr">
                              <div className="community_form_filed_wrapper">
                                <label className="community_form_label">
                                  Min. BHK
                                </label>
                                <div className="community_input_wrapper_div">
                                  <select
                                    // placeholder="Enter BHK"
                                    type="text"
                                    value={clientInHandData.minBhk}
                                    onChange={(e) => {
                                      setClientInHandData((prevData) => ({
                                        ...prevData,
                                        minBhk: e.target.value,
                                      }));
                                    }}
                                  >
                                    <option value="">Select Min. Bhk</option>
                                    {bhk.map((bhk) => (
                                      <option key={bhk._id} value={bhk._id}>
                                        {bhk.bhk}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>
                            </div>
                            <div className="left_form_wrappr">
                              <div className="community_form_filed_wrapper">
                                <label className="community_form_label">
                                  Max. BHK
                                </label>
                                <div className="community_input_wrapper_div">
                                  <select
                                    // placeholder="Enter BHK"
                                    type="text"
                                    value={clientInHandData.maxBhk}
                                    onChange={(e) => {
                                      setClientInHandData((prevData) => ({
                                        ...prevData,
                                        maxBhk: e.target.value,
                                      }));
                                    }}
                                  >
                                    <option value="">Select Max. Bhk</option>
                                    {bhk.map((bhk) => (
                                      <option key={bhk._id} value={bhk._id}>
                                        {bhk.bhk}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="community_form_filed_wrapper">
                            <label className="community_form_label">
                              Fill Your Complete Requirement
                            </label>
                            <div className="community_input_wrapper_div">
                              <textarea
                                placeholder="Enter Preferred Localities"
                                type="text"
                              ></textarea>
                            </div>
                          </div>
                          <div className="community_form_submit_div">
                            <button onClick={(e) => submitButtonfunc(e)}>
                              Submit
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>

              <div className="community_property_details_wrapper2">
                <div className="property_img_details_div2">
                  {propertyInHand.length > 0 ? (
                    <div>
                      <h1 className="prefered_cities_head2">
                        Property In Hand
                      </h1>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          rowGap: "20px",
                        }}
                      >
                        {propertyInHand.map((e, i) => {
                          return (
                            <>
                              <div className="property_img_details_inside_content_wrapper2">
                                <div className="community_property_img5">
                                  <img
                                    // src={e?.images[0] || noimage}
                                    src={getFirstImage(e?.images) || noimage}
                                    alt="hello"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      setIsMediaSliderOpen(true);
                                      setImagesForMediaSlider(e?.images);
                                    }}
                                  ></img>
                                </div>
                                <div className="community_property_details_wrapper5">
                                  <div className="community_property_details_5">
                                    <div className="community_property_5">
                                      <div className="property_para_div">
                                        <p className="property_data_para">
                                          Property Type:
                                        </p>
                                        <p className="property_data_para2">
                                          {e?.propertytype?.propertyType ||
                                            "N/A"}
                                        </p>
                                      </div>

                                      <div className="property_para_div">
                                        <p className="property_data_para">
                                          BHK:
                                        </p>
                                        <p className="property_data_para2">
                                          {e?.bhk.bhk || "N/A"}
                                        </p>
                                      </div>
                                    </div>

                                    <div className="community_property_5">
                                      <div className="property_para_div">
                                        <p className="property_data_para">
                                          Address:
                                        </p>
                                        <p className="property_data_para2">
                                          {e?.address || "N/A"}
                                        </p>
                                      </div>

                                      <div className="property_para_div">
                                        <p className="property_data_para">
                                          Contact:
                                        </p>
                                        <p className="property_data_para2">
                                          {e?.phoneNo || "N/A"}
                                        </p>
                                      </div>
                                    </div>

                                    <div className="community_property_5">
                                      <div className="property_para_div">
                                        <p className="property_data_para">
                                          Area:
                                        </p>
                                        <p className="property_data_para2">
                                          {e?.area || "N/A"}
                                          {e?.areaUnit || "N/A"}
                                        </p>
                                      </div>

                                      {/* <div className="property_para_div">
                                        <p className="property_data_para">
                                          Extra:
                                        </p>
                                        <p className="property_data_para2">
                                          --
                                        </p>
                                      </div> */}
                                    </div>

                                    <div className="community_property_5">
                                      <div className="property_para_div">
                                        <p className="property_data_para">
                                          Floor:
                                        </p>
                                        <p className="property_data_para2">
                                          {e?.floor?.floor || "N/A"}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="property_icons_div5">
                                    <div
                                      style={{
                                        padding: "10px 15px 10px 0px",
                                        display: "flex",
                                        justifyContent: "flex-end",
                                      }}
                                    >
                                      {/* <div className="community_property_icons_div">
                                        <div className="icon_no_1">
                                          <img src={heart}></img>
                                        </div>
                                        <div className="icon_no_1">
                                          <img src={whatsapp}></img>
                                        </div>

                                        <div className="icon_no_1">
                                          <img src={send}></img>
                                        </div>
                                      </div> */}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          );
                        })}
                      </div>
                    </div>
                  ) : (
                    <>
                      <div>
                        <h1 className="prefered_cities_head2">
                          No Properties found in hand
                        </h1>
                      </div>
                    </>
                  )}
                </div>

                {isPropertyDealer ? (
                  <div className="client_property_details2">
                    <div className="client_in_hand_wrapper">
                      <div className="client_head_div">
                        <h3>Property In Hand (Requirement) </h3>
                      </div>
                      <div className="community_form_wrapper_div">
                        <form
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            rowGap: "10px",
                          }}
                          onSubmit={handleSubmit}
                        >
                          <div className="row">
                            <div className="community_input_wrapper_div mt-3">
                              <label>Property Type</label>
                              <select
                                // className="form-control"
                                value={selectedPropertyType}
                                onChange={(e) =>
                                  setSelectedPropertyType(e.target.value)
                                }
                                required
                              >
                                <option value="">Select Property Type</option>
                                {propertyType.map((type) => (
                                  <option
                                    key={type._id}
                                    value={type.propertyType}
                                  >
                                    {type.propertyType}
                                  </option>
                                ))}
                              </select>
                            </div>
                            <div className="community_input_wrapper_div mt-3">
                              <label>City</label>
                              <select
                                // className="form-control"
                                value={selectedCity}
                                onChange={(e) =>
                                  setSelectedCity(e.target.value)
                                }
                                required
                              >
                                <option value="">Select City</option>
                                {cities.map((city) => (
                                  <option key={city._id} value={city.name}>
                                    {city.name}
                                  </option>
                                ))}
                              </select>
                            </div>
                            <div className="community_input_wrapper_div mt-3">
                              <label>Facing</label>
                              <select
                                // className="form-control"
                                value={selectedFacing}
                                onChange={(e) =>
                                  setSelectedFacing(e.target.value)
                                }
                                required
                              >
                                <option value="">Select Facing</option>
                                {facings.map((facing) => (
                                  <option
                                    key={facing._id}
                                    value={facing.facing}
                                  >
                                    {facing.facing}
                                  </option>
                                ))}
                              </select>
                            </div>

                            {/* Features Input */}
                            <div className="community_input_wrapper_div mt-3">
                              <label>Features</label>
                              <div className="d-flex align-items-center gap-2 add_features">
                                <input
                                  type="text"
                                  className="form-control"
                                  value={featureInput}
                                  onChange={(e) =>
                                    setFeatureInput(e.target.value)
                                  }
                                  placeholder="Enter a feature"
                                />
                                <button
                                  type="button"
                                  className="btn btn-secondary ml-2"
                                  onClick={handleAddFeature}
                                >
                                  Add
                                </button>
                              </div>
                              <div className="mt-2">
                                {features.map((feature, index) => (
                                  <span
                                    key={index}
                                    className="badge badge-primary mr-2"
                                    style={{
                                      display: "inline-block",
                                      backgroundColor: "#007bff",
                                      color: "#fff",
                                      padding: "8px 12px",
                                      borderRadius: "20px",
                                      fontSize: "14px",
                                      margin: "5px",
                                      cursor: "pointer",
                                      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
                                      transition: "all 0.3s ease",
                                    }}
                                    onClick={() => handleRemoveFeature(feature)}
                                  >
                                    {feature}{" "}
                                    <span
                                      style={{
                                        marginLeft: "5px",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      ×
                                    </span>
                                  </span>
                                ))}
                              </div>
                            </div>

                            <div className="community_input_wrapper_div mt-3">
                              <label>Locality</label>
                              <input
                                type="text"
                                className="form-control"
                                value={locality}
                                onChange={(e) => setlocality(e.target.value)}
                                placeholder="Enter Locality"
                                required
                              />
                            </div>
                            <div className="community_input_wrapper_div mt-3">
                              <label>Address</label>
                              <input
                                type="text"
                                className="form-control"
                                value={address}
                                onChange={(e) => setAddress(e.target.value)}
                                placeholder="Enter Address"
                                required
                              />
                            </div>
                            <div className="community_input_wrapper_div mt-3">
                              <label>Area</label>
                              <input
                                type="text"
                                className="form-control"
                                value={area}
                                onChange={(e) => setArea(e.target.value)}
                                placeholder="Enter Area"
                                required
                              />
                            </div>
                            <div className="community_input_wrapper_div mt-3">
                              <label>BHK</label>
                              <select
                                // className="form-control"
                                value={selectedBhk}
                                onChange={(e) => setSelectedBhk(e.target.value)}
                                required
                              >
                                <option value="">Select Bhk</option>

                                {bhk.map((bhk) => (
                                  <option key={bhk._id} value={bhk.bhk}>
                                    {bhk.bhk}
                                  </option>
                                ))}
                              </select>
                            </div>
                            <div className="community_input_wrapper_div mt-3">
                              <label>Floor</label>
                              <select
                                // className="form-control"
                                value={selectedFloor}
                                onChange={(e) =>
                                  setSelectedFloor(e.target.value)
                                }
                                required
                              >
                                <option value="">Select Floor</option>

                                {floor.map((floor) => (
                                  <option key={floor._id} value={floor.floor}>
                                    {floor.floor}
                                  </option>
                                ))}
                              </select>
                            </div>
                            <div className="community_input_wrapper_div mt-3">
                              <label>Owner Name</label>
                              <input
                                type="text"
                                className="form-control"
                                value={ownerName}
                                onChange={(e) => setOwnerName(e.target.value)}
                                placeholder="Enter Owner Name"
                                required
                              />
                            </div>
                            <div className="community_input_wrapper_div mt-3">
                              <label>Phone Number</label>
                              <input
                                type="tel"
                                className="form-control"
                                value={phoneNumber}
                                onChange={(e) => setPhoneNumber(e.target.value)}
                                placeholder="Enter Phone Number"
                                required
                              />
                            </div>
                            <div className="community_input_wrapper_div mt-3">
                              <label>Price</label>
                              <input
                                type="number"
                                className="form-control"
                                value={price}
                                onChange={(e) => setPrice(e.target.value)}
                                placeholder="Enter Price"
                                required
                              />
                            </div>
                            <div className="community_input_wrapper_div mt-3">
                              <label>Upload Images</label>
                              <input
                                type="file"
                                className="form-control"
                                onChange={handleImageUpload}
                                multiple
                                accept="image/*"
                                required
                              />

                              {images.length > 0 && (
                                <div className="community_input_wrapper_div mt-3">
                                  <label>Image Preview:</label>
                                  <div className="d-flex flex-wrap">
                                    {images.map((img, index) => (
                                      <img
                                        key={index}
                                        src={img}
                                        alt={`Preview ${index + 1}`}
                                        style={{
                                          width: "100px",
                                          height: "100px",
                                          margin: "5px",
                                        }}
                                      />
                                    ))}
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="community_form_submit_div">
                            <button>Submit</button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </>
        )}
      </>

      {modalOpen && (
        <div className="modal-overlay">
          <CommunityCover modalChange={modalChange} />
        </div>
      )}

      {showUpdateProfileModal && (
        <div style={styles.modalOverlay}>
          <div style={styles.modal}>
            {/* <form onSubmit={handleSubmit}>
              <div>
                <label>Name: </label>
                <input
                  type="text"
                  name="name"
                  value={updateData.companyName}
                  // onChange={handleChange}
                />
              </div>
              <div style={{ marginTop: '20px' }}>
                <button type="submit">Submit</button>
                <button
                  type="button"
                  onClick={() => setShowUpdateProfileModal(false)}
                  style={{ marginLeft: '10px' }}
                >
                  Cancel
                </button>
              </div>
            </form> */}
            <div className="client_in_hand_wrapper">
              <div className="client_head_div">
                <h3>Update Profile </h3>
              </div>
              <div className="community_form_wrapper_div">
                <form
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    rowGap: "10px",
                  }}
                >
                  <div className="community_input_flex_wrapper">
                    <div className="left_form_wrappr">
                      <div className="community_form_filed_wrapper">
                        <label className="community_form_label">Banner</label>
                        <div className="community_input_wrapper_div">
                          <img
                            src={updateData?.image}
                            style={{ maxHeight: "50px", maxWidth: "100%" }}
                          />
                          <input
                            type="file"
                            name="image"
                            className="form-control"
                            onChange={(e) => handleProfileImageUpload(e)}
                            accept="image/*"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="community_form_filed_wrapper">
                      <label className="community_form_label">Logo</label>
                      <div className="community_input_wrapper_div">
                        <img
                          src={updateData?.logo}
                          style={{ maxHeight: "50px", maxWidth: "100%" }}
                        />
                        <input
                          type="file"
                          name="logo"
                          className="form-control"
                          onChange={(e) => handleProfileImageUpload(e)}
                          accept="image/*"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="community_input_flex_wrapper">
                    <div className="left_form_wrappr">
                      <div className="community_form_filed_wrapper">
                        <label className="community_form_label">Name</label>
                        <div className="community_input_wrapper_div">
                          <input
                            value={updateData?.fullName}
                            onChange={(e) =>
                              setUpdateData({
                                ...updateData,
                                fullName: e.target.value,
                              })
                            }
                            placeholder="Full name"
                            type="text"
                          ></input>
                        </div>
                      </div>
                    </div>
                    <div className="community_form_filed_wrapper">
                      <label className="community_form_label">Email</label>
                      <div className="community_input_wrapper_div">
                        <input
                          value={updateData?.email}
                          onChange={(e) =>
                            setUpdateData({
                              ...updateData,
                              email: e.target.value,
                            })
                          }
                          placeholder="Email address"
                          type="text"
                        ></input>
                      </div>
                    </div>
                  </div>

                  <div className="community_input_flex_wrapper">
                    <div className="left_form_wrappr">
                      <div className="community_form_filed_wrapper">
                        <label className="community_form_label">Phone</label>
                        <div className="community_input_wrapper_div">
                          <input
                            value={updateData?.mobileNo}
                            onChange={(e) =>
                              setUpdateData({
                                ...updateData,
                                mobileNo: e.target.value,
                              })
                            }
                            placeholder="Phone number"
                            type="text"
                          ></input>
                        </div>
                      </div>
                    </div>
                    <div className="community_form_filed_wrapper">
                      <label className="community_form_label">Company</label>
                      <div className="community_input_wrapper_div">
                        <input
                          value={updateData?.companyName}
                          onChange={(e) =>
                            setUpdateData({
                              ...updateData,
                              companyName: e.target.value,
                            })
                          }
                          placeholder="Company name"
                          type="text"
                        ></input>
                      </div>
                    </div>
                  </div>

                  <div className="community_input_flex_wrapper">
                    <div className="left_form_wrappr">
                      <div className="community_form_filed_wrapper">
                        <label className="community_form_label">City</label>
                        <div className="community_input_wrapper_div">
                          <select
                            // className="form-control"
                            value={updateData?.city}
                            onChange={(e) =>
                              setUpdateData({
                                ...updateData,
                                city: e.target.value,
                              })
                            }
                          >
                            <option value="">Select City</option>
                            {cities.map((city) => (
                              <option key={city._id} value={city._id}>
                                {city.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="community_form_filed_wrapper">
                      <label className="community_form_label">
                        Work Experience
                      </label>
                      <div className="community_input_wrapper_div">
                        <input
                          value={updateData?.workExpYear}
                          onChange={(e) =>
                            setUpdateData({
                              ...updateData,
                              workExpYear: e.target.value,
                            })
                          }
                          placeholder="Work Experience in years"
                          type="text"
                        ></input>
                      </div>
                    </div>
                  </div>

                  <div className="community_form_filed_wrapper">
                    <label className="community_form_label">Address</label>
                    <div className="community_input_wrapper_div">
                      <input
                        value={updateData?.address}
                        onChange={(e) =>
                          setUpdateData({
                            ...updateData,
                            address: e.target.value,
                          })
                        }
                        placeholder="Major localities"
                        type="text"
                      ></input>
                    </div>
                  </div>

                  {/* <div className="community_form_filed_wrapper">
                    <label className="community_form_label">
                      Fill Your Complete Requirement
                    </label>
                    <div className="community_input_wrapper_div">
                      <textarea
                        placeholder="Enter Preferred Localities"
                        type="text"
                      ></textarea>
                    </div>
                  </div> */}
                  <div className="community_form_submit_div">
                    <button onClick={(e) => updateProfileData(e)}>
                      Submit
                    </button>
                    <button
                      style={{ marginLeft: "1em" }}
                      onClick={() => {
                        setUserId("");
                        fetchLoginProfile();
                        setShowUpdateProfileModal(!showUpdateProfileModal);
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CommunityFav;
